import React, {useEffect, useMemo, useState} from 'react';
import {Modal, TouchableWithoutFeedback} from 'react-native';

import {Button} from '../../Interface/Forms/Buttons/Button';
import {useTheme} from 'styled-components/native';

import {
  ModalOverlay,
  ModalContent,
  ModalTitle,
  ModalText,
  ModalTextBold,
  ModalCheckboxRow,
  ModalCheckboxText,
  TermCheckIcon,
} from './styles';

interface Props {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  prazoPixReembolso?: string;
  loadingRemoteConfigs?: boolean;
  textoFinal?: string;
}

export function RefundTermsModal({
  visible,
  onClose,
  onConfirm,
  prazoPixReembolso,
  loadingRemoteConfigs,
  textoFinal,
}: Props) {
  const theme = useTheme();
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (visible) {
      setAccepted(false);
    }
  }, [visible]);

  const handleConfirm = () => {
    if (!accepted) return;
    onConfirm();
  };

  const parsedFinalText = useMemo(() => {
    if (!textoFinal) return null;
    try {
      const parsed = JSON.parse(textoFinal);
      if (
        Array.isArray(parsed) &&
        parsed.every(
          (item) =>
            item &&
            typeof item.value === 'string' &&
            (item.type === 'text' || item.type === 'textBold'),
        )
      ) {
        return parsed as {type: 'text' | 'textBold'; value: string}[];
      }
    } catch {
      return null;
    }

    return null;
  }, [textoFinal]);

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}>
      <TouchableWithoutFeedback onPress={onClose}>
        <ModalOverlay>
          <TouchableWithoutFeedback>
            <ModalContent>
              <ModalTitle>
                Declaro que estou ciente dos seguintes prazos para finalização do
                reembolso:
              </ModalTitle>
              <ModalText>
                Compras via PIX - {loadingRemoteConfigs ? '••••' : prazoPixReembolso}{' '}
                dias úteis a partir do recebimento.
              </ModalText>
              <ModalText>
                Compras via Cartão de Crédito - O reembolso é definido pela
                operadora do cartão.
              </ModalText>
              <ModalText>
                {parsedFinalText
                  ? parsedFinalText.map((item, index) => (
                      <ModalText
                        key={`${item.type}-${index}`}
                        style={{
                          fontFamily:
                            item.type === 'textBold'
                              ? theme.fonts.semibold
                              : theme.fonts.regular,
                        }}>
                        {item.value}
                        {index < parsedFinalText.length - 1 ? ' ' : ''}
                      </ModalText>
                    ))
                  : textoFinal ||
                    'Em conformidade com o Código de Defesa do Consumidor (art. 14) e com as diretrizes do Banco Central, o reembolso será realizado exclusivamente ao titular do pagamento, mediante correspondência do CPF, como medida de prevenção a fraudes e proteção financeira dos usuários.'}
              </ModalText>

              <ModalCheckboxRow
                activeOpacity={0.7}
                onPress={() => setAccepted(!accepted)}>
                <TermCheckIcon
                  name={accepted ? 'check-square' : 'square-o'}
                  checked={accepted}
                />
                <ModalCheckboxText>Estou ciente e concordo</ModalCheckboxText>
              </ModalCheckboxRow>

              <Button title="Solicitar Reembolso" enabled={accepted} onPress={handleConfirm} />
            </ModalContent>
          </TouchableWithoutFeedback>
        </ModalOverlay>
      </TouchableWithoutFeedback>
    </Modal>
  );
}
